/**
 * MainLayout — global authenticated app shell.
 *
 * Previously a left sidebar (permanent MUI Drawer, 240px) with a nested
 * Execution/Analytics/Administration group structure and a profile menu
 * pinned to its footer. Per the top-nav redesign, the sidebar is fully
 * removed (not collapsed/icon-only) in favor of `TopNav` — a single
 * horizontal header — so the main content area reclaims 100% of the
 * viewport width with zero left offset. Every route/permission/page
 * component below is completely unchanged; only where navigation lives
 * moved, exactly as it did in the AppBar -> sidebar move this same
 * component went through earlier (see git history).
 */
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import TopNav from "@/layouts/TopNav";

export function MainLayout() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <TopNav />
      <Box component="main" sx={{ flexGrow: 1, width: "100%", p: 3 }}>
        <Outlet />
      </Box>
    </Box>
  );
}

export default MainLayout;
